import AgeBanner from "../components/AgeBanner";
import Footer from "../components/Footer";
import Navigation from "../components/Navigation";
import { usePageTitle } from "../hook/usePageTitle";

const TermsPage = () => {
    usePageTitle("Terms of Service");
    return (
        <>
            <AgeBanner />
            <Navigation />
            <div className="policy-page">
                <div className="policy-hero">
                    <h1>Terms of <span className="highlight">Service</span></h1>
                </div>

                <div className="policy-content">
                    <p className="last-updated">Last Updated: January 28, 2026</p>

                    <h2>1. Acceptance of Terms</h2>
                    <p>By accessing and using Vinor ("the Platform," "we," "us," or "our"), you agree to be bound by
                        these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our Platform.
                    </p>
                    <p>These Terms constitute a legally binding agreement between you and Vinor regarding your use of the
                        Platform and any games or services provided therein.</p>

                    <h2>2. Eligibility</h2>
                    <p>To use Vinor, you must:</p>
                    <ul>
                        <li>Be at least <strong>18 years of age</strong> or the age of majority in your jurisdiction</li>
                        <li>Have the legal capacity to enter into binding agreements</li>
                        <li>Not be prohibited from using the Platform under applicable laws</li>
                        <li>Access the Platform from a jurisdiction where such access is legal</li>
                    </ul>
                    <p>By using the Platform, you represent and warrant that you meet all eligibility requirements.</p>

                    <h2>3. Nature of the Platform</h2>
                    <p>Vinor is a <strong>social casino entertainment platform</strong>. You acknowledge and agree that:
                    </p>
                    <ul>
                        <li>All games are for entertainment purposes only</li>
                        <li>No real money gambling or betting takes place on the Platform</li>
                        <li>Virtual currency has no real-world monetary value</li>
                        <li>There are no cash prizes, rewards, or payouts</li>
                        <li>Success in games does not imply success in real gambling</li>
                    </ul>

                    <h2>4. User Conduct</h2>
                    <p>When using Vinor, you agree to:</p>
                    <ul>
                        <li>Use the Platform only for lawful purposes</li>
                        <li>Not attempt to exploit, hack, or manipulate games or systems</li>
                        <li>Not use automated scripts, bots, or third-party software</li>
                        <li>Not interfere with or disrupt the Platform's operations</li>
                        <li>Not impersonate any person or entity</li>
                        <li>Not engage in any activity that violates these Terms</li>
                    </ul>

                    <h2>5. Virtual Currency and Items</h2>
                    <p>Any virtual currency, credits, coins, or items provided on Vinor:</p>
                    <ul>
                        <li>Are licensed to you for use on the Platform only</li>
                        <li>Have no real-world value and cannot be exchanged for money</li>
                        <li>May be modified, suspended, or terminated at our discretion</li>
                        <li>Are non-refundable and non-transferable</li>
                        <li>Do not constitute property rights</li>
                    </ul>

                    <h2>6. Intellectual Property</h2>
                    <p>All content on Vinor, including but not limited to:</p>
                    <ul>
                        <li>Graphics, logos, and visual designs</li>
                        <li>Game mechanics and software</li>
                        <li>Text, audio, and animations</li>
                        <li>Trademarks and trade dress</li>
                    </ul>
                    <p>Are owned by or licensed to Vinor and protected by intellectual property laws. You may not
                        reproduce, distribute, modify, or create derivative works without our express written permission.</p>

                    <h2>7. Privacy</h2>
                    <p>Your use of the Platform is also governed by our Privacy Policy, which describes how we collect, use, and
                        protect your information. By using Vinor, you consent to the practices described in our Privacy
                        Policy.</p>

                    <h2>8. Disclaimers</h2>
                    <p>THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR
                        IMPLIED. We do not warrant that:</p>
                    <ul>
                        <li>The Platform will be uninterrupted or error-free</li>
                        <li>Defects will be corrected</li>
                        <li>The Platform is free of viruses or harmful components</li>
                        <li>The results of using the Platform will meet your expectations</li>
                    </ul>

                    <h2>9. Limitation of Liability</h2>
                    <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, Vinor and its affiliates, officers, directors, employees,
                        and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages
                        arising from or related to your use of the Platform.</p>

                    <h2>10. Indemnification</h2>
                    <p>You agree to indemnify, defend, and hold harmless Vinor and its affiliates from any claims,
                        damages, losses, or expenses arising from:</p>
                    <ul>
                        <li>Your use of the Platform</li>
                        <li>Your violation of these Terms</li>
                        <li>Your violation of any third-party rights</li>
                        <li>Your violation of applicable laws</li>
                    </ul>

                    <h2>11. Modifications to Terms</h2>
                    <p>We reserve the right to modify these Terms at any time. Changes will be effective upon posting to the
                        Platform. Your continued use of the Platform after changes constitutes acceptance of the modified Terms.
                    </p>

                    <h2>12. Termination</h2>
                    <p>We may terminate or suspend your access to the Platform at any time, with or without cause, and with or
                        without notice. Upon termination, all rights granted to you under these Terms will immediately cease.
                    </p>

                    <h2>13. Governing Law</h2>
                    <p>These Terms shall be governed by and construed in accordance with applicable laws, without regard to
                        conflicts of law principles.</p>

                    <h2>14. Severability</h2>
                    <p>If any provision of these Terms is found to be unenforceable, the remaining provisions will continue in
                        full force and effect.</p>

                    <h2>15. Contact</h2>
                    <p>For questions about these Terms of Service, please navigate to our contact section on the homepage.</p>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default TermsPage